import { IntlShape } from 'react-intl';

export const profileTranslations = (intl: IntlShape) => ({
  profile: {
    title: intl.formatMessage({
      defaultMessage: 'Profilo utente',
      id: 'profile.title',
    }),
    breadcrumb: intl.formatMessage({
      defaultMessage: 'Profilo',
      id: 'profile.breadcrumb',
    }),
    tabs: {
      personalData: {
        title: intl.formatMessage({
          defaultMessage: 'Dati personali',
          id: 'profile.tabs.personalData.title',
        }),
      },
      changePass: {
        title: intl.formatMessage({
          defaultMessage: 'Cambia Password',
          id: 'profile.tabs.changePass.title',
        }),
        fields: {
          oldPass: intl.formatMessage({
            defaultMessage: 'Password attuale',
            id: 'profile.tabs.changePass.fields.oldPass',
          }),
          newPass: intl.formatMessage({
            defaultMessage: 'Nuova password',
            id: 'profile.tabs.changePass.fields.newPass',
          }),
          confirmPass: intl.formatMessage({
            defaultMessage: 'Conferma nuova password',
            id: 'profile.tabs.changePass.fields.confirmPass',
          }),
        },
      },
    },
    fields: {
      name: intl.formatMessage({
        defaultMessage: 'Nome',
        id: 'profile.fields.name',
      }),
      surname: intl.formatMessage({
        defaultMessage: 'Cognome',
        id: 'profile.fields.surname',
      }),
      email: intl.formatMessage({
        defaultMessage: 'Email',
        id: 'profile.fields.email',
      }),
      category: intl.formatMessage({
        defaultMessage: 'Categoria',
        id: 'profile.fields.category',
      }),
      organisation: intl.formatMessage({
        defaultMessage: 'Testata',
        id: 'profile.fields.organisation',
      }),
      organisationSub: intl.formatMessage({
        defaultMessage:
          'È necessario indicare una testata. Sarà comunque possibile modificarla in fase di richiesta accredito',
        id: 'profile.fields.organisationSub',
      }),
      marketing: intl.formatMessage({
        defaultMessage: 'Acconsenti a profilazione marketing',
        id: 'profile.fields.marketing',
      }),
    },
    snackbar: {
      passwordSuccess: intl.formatMessage({
        defaultMessage: 'Password modificata con successo',
        id: 'profile.snackbar.passwordSuccess',
      }),
      updateSuccess: intl.formatMessage({
        defaultMessage: 'Utente correttamente modificato',
        id: 'profile.snackbar.updateSuccesss',
      }),
    },
  },
});
